import React from 'react';

import Box from '@mui/material/Box';

import PackageChip from './PackageChip.jsx';

function PackageChips({ commission }) {
  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '0.25rem' }}>
      {commission.TrackingID.split(',').map((id) => (
        <PackageChip key={id} id={id} />
      ))}
    </Box>
  );
}

export default React.memo(PackageChips);
